var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    { attrs: { value: _vm.dialog, "max-width": "550", persistent: "" } },
    [
      _vm.payslip
        ? _c(
            "v-card",
            [
              _c(
                "v-form",
                {
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                      return _vm.confirm.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("v-card-title", [
                    _c("span", { staticClass: "headline" }, [
                      _vm._v("Anular recibo"),
                    ]),
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _c("p", { staticClass: "mb-5" }, [
                        _vm._v(" El recibo "),
                        _c("b", [_vm._v(_vm._s(_vm.payslip.file_name))]),
                        _vm.payslip.legajo
                          ? _c("span", [
                              _vm._v(" de "),
                              _c("b", [
                                _vm._v(
                                  _vm._s(_vm.legajoLabel(_vm.payslip.legajo))
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" queda anulado en el historial, no se borra. "),
                      ]),
                      _c("v-textarea", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required|max:1000",
                            expression: "'required|max:1000'",
                          },
                        ],
                        attrs: {
                          label: "Motivo*",
                          name: "reason",
                          "data-vv-as": "motivo",
                          rows: "3",
                        },
                        model: {
                          value: _vm.reason,
                          callback: function ($$v) {
                            _vm.reason = $$v
                          },
                          expression: "reason",
                        },
                      }),
                      _c("span", { staticClass: "red--text" }, [
                        _vm._v(_vm._s(_vm.errors.first("reason"))),
                      ]),
                      _c("v-file-input", {
                        staticClass: "mt-4",
                        attrs: {
                          accept: ".pdf",
                          label: "Recibo de reemplazo (opcional)",
                          "prepend-icon": "mdi-file-pdf-box",
                          "show-size": "",
                        },
                        model: {
                          value: _vm.file,
                          callback: function ($$v) {
                            _vm.file = $$v
                          },
                          expression: "file",
                        },
                      }),
                      _c("v-label", [
                        _vm._v("Se carga con el mismo legajo, período y tipo."),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "error",
                            text: "",
                            disabled: _vm.loading,
                          },
                          on: { click: _vm.close },
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "success",
                            text: "",
                            type: "submit",
                            loading: _vm.loading,
                          },
                        },
                        [_vm._v("Anular")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }